import { useInfiniteQuery } from '@tanstack/react-query';
import { requestLogsApi } from '../api/requestLogsApi';
import type { RequestLogFilters } from '../types/requestLog';

/**
 * TanStack Query v5 useInfiniteQuery for cursor-based (keyset) paging.
 * queryKey: ['gateway', 'request-logs', 'list', filters]
 *
 * getNextPageParam: returns nextCursor string when hasMore=true, else undefined.
 * Each page is a CursorResponse<RequestLogDto>.
 */
export function useRequestLogs(filters: RequestLogFilters) {
  return useInfiniteQuery({
    queryKey: ['gateway', 'request-logs', 'list', filters] as const,
    queryFn: ({ pageParam }) =>
      requestLogsApi.list({
        ...filters,
        cursor: typeof pageParam === 'string' ? pageParam : null,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore && lastPage.nextCursor ? lastPage.nextCursor : undefined,
    staleTime: 30_000,
  });
}
